import { HiMiniXCircle } from 'react-icons/hi2';
import type { IconBaseProps } from 'react-icons/lib';
import {
  TbArrowLeft,
  TbArrowUp,
  TbBookmark,
  TbCalendar,
  TbCalendarDown,
  TbCalendarUp,
  TbCheck,
  TbChevronDown,
  TbChevronRight,
  TbCircle,
  TbDots,
  TbIcons,
  TbLayoutDashboard,
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarLeftExpand,
  TbLogout,
  TbMailCheck,
  TbNotebook,
  TbPencil,
  TbPhoto,
  TbPin,
  TbPlus,
  TbSearch,
  TbSettings,
  TbSmartHome,
  TbSortAscendingLetters,
  TbSortAZ,
  TbSortDescendingLetters,
  TbStar,
  TbStarFilled,
  TbStarOff,
  TbTag,
  TbTagMinus,
  TbTagOff,
  TbTagPlus,
  TbTrash,
  TbTrashOff,
  TbTrashX,
  TbUserCircle,
  TbX
} from 'react-icons/tb';

type Props = {
  name: IconName;
} & IconBaseProps;

export const Icon = ({ name, ...rest }: Props) => {
  if (name === 'account') {
    return <TbUserCircle {...rest} />;
  }
  if (name === 'all-items') {
    return <TbIcons {...rest} />;
  }

  if (name === 'arrow-left') {
    return <TbArrowLeft {...rest} />;
  }

  if (name === 'arrow-up') {
    return <TbArrowUp {...rest} />;
  }

  if (name === 'bookmark') {
    return <TbBookmark {...rest} />;
  }

  if (name === 'check') {
    return <TbCheck {...rest} />;
  }

  if (name === 'chevron-down') {
    return <TbChevronDown {...rest} />;
  }

  if (name === 'chevron-right') {
    return <TbChevronRight {...rest} />;
  }

  if (name === 'circle') {
    return <TbCircle {...rest} />;
  }

  if (name === 'dashboards') {
    return <TbLayoutDashboard {...rest} />;
  }

  if (name === 'dots-horizontal') {
    return <TbDots {...rest} />;
  }

  if (name === 'edit') {
    return <TbPencil {...rest} />;
  }

  if (name === 'home') {
    return <TbSmartHome {...rest} />;
  }

  if (name === 'image') {
    return <TbPhoto {...rest} />;
  }

  if (name === 'main-check') {
    return <TbMailCheck {...rest} />;
  }

  if (name === 'notebook') {
    return <TbNotebook {...rest} />;
  }

  if (name === 'pin') {
    return <TbPin {...rest} />;
  }

  if (name === 'plus') {
    return <TbPlus {...rest} />;
  }

  if (name === 'search') {
    return <TbSearch {...rest} />;
  }

  if (name === 'settings') {
    return <TbSettings {...rest} />;
  }

  if (name === 'sidebar-left-collapse') {
    return <TbLayoutSidebarLeftCollapse {...rest} />;
  }

  if (name === 'sidebar-left-expand') {
    return <TbLayoutSidebarLeftExpand {...rest} />;
  }

  if (name === 'sign-out') {
    return <TbLogout {...rest} />;
  }

  if (name === 'sort-date') {
    return <TbCalendar {...rest} />;
  }

  if (name === 'sort-date-ascending') {
    return <TbCalendarUp {...rest} />;
  }

  if (name === 'sort-date-descending') {
    return <TbCalendarDown {...rest} />;
  }

  if (name === 'sort-name') {
    return <TbSortAZ {...rest} />;
  }

  if (name === 'sort-name-ascending') {
    return <TbSortAscendingLetters {...rest} />;
  }

  if (name === 'sort-name-descending') {
    return <TbSortDescendingLetters {...rest} />;
  }

  if (name === 'star') {
    return <TbStar {...rest} />;
  }

  if (name === 'star-filled') {
    return <TbStarFilled {...rest} />;
  }

  if (name === 'star-off') {
    return <TbStarOff {...rest} />;
  }

  if (name === 'tag') {
    return <TbTag {...rest} />;
  }

  if (name === 'tag-off') {
    return <TbTagOff {...rest} />;
  }

  if (name === 'tag-minus') {
    return <TbTagMinus {...rest} />;
  }

  if (name === 'tag-plus') {
    return <TbTagPlus {...rest} />;
  }

  if (name === 'trash') {
    return <TbTrash {...rest} />;
  }

  if (name === 'trash-off') {
    return <TbTrashOff {...rest} />;
  }

  if (name === 'trash-x') {
    return <TbTrashX {...rest} />;
  }

  if (name === 'x') {
    return <TbX {...rest} />;
  }

  if (name === 'x-circle-filled') {
    return <HiMiniXCircle {...rest} />;
  }

  return;
};

export type IconName =
  | 'account'
  | 'all-items'
  | 'arrow-left'
  | 'arrow-up'
  | 'bookmark'
  | 'dots-horizontal'
  | 'edit'
  | 'check'
  | 'chevron-down'
  | 'chevron-right'
  | 'circle'
  | 'dashboards'
  | 'home'
  | 'image'
  | 'main-check'
  | 'notebook'
  | 'plus'
  | 'pin'
  | 'search'
  | 'settings'
  | 'sidebar-left-collapse'
  | 'sidebar-left-expand'
  | 'sign-out'
  | 'sort-date'
  | 'sort-date-ascending'
  | 'sort-date-descending'
  | 'sort-name'
  | 'sort-name-ascending'
  | 'sort-name-descending'
  | 'star'
  | 'star-filled'
  | 'star-off'
  | 'tag'
  | 'tag-minus'
  | 'tag-plus'
  | 'tag-off'
  | 'trash'
  | 'trash-off'
  | 'trash-x'
  | 'x'
  | 'x-circle-filled';

export type { IconBaseProps } from 'react-icons';
